import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { Location } from '@angular/common';
import { SelectItem } from 'primeng/api';
import { Subject } from "rxjs";
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from "@ngrx/store";
import * as fromStore from "../../../store";
import * as fromFeature from "../../../my-features";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { MessageService } from 'primeng/api';
import { UpdateInfoModel } from '../../../my-features/updateInfo/update-info.model';
import { ApiKeyService } from "../../../services/api-key.service";
import { CryptoService} from '../../../services/crypto.service';
import { DialogComponent } from '../../../dialog/dialog.component';
import { Router } from '@angular/router';
import {
  updateInfoType,
  statusType
} from '../../../shareModel';

@Component({
  standalone: false,
  selector: 'app-api-detail',
  templateUrl: './api-mgt-detail.component.html',
  styleUrls: ['./api-mgt-detail.component.css']
})
export class ApiMgtDetailComponent implements OnInit {
  private componentDestroyed = new Subject();
  UpdateInfoParam = {} as UpdateInfoModel;
  apiKeyUsage = [];
  apikeydetailInfo = {
    account: '',
    apiName: '',
    apiKey: '',
    apiKeyId: '',
    createDate: '',
    expiredDate: '',
    status: '',
    expired: false
  };
  LicenseData_cols: any[] = [
    { field: 'type', header: this.translateService.instant('API Type'), class: 'col-nowrap' },
    { field: 'usage', header: this.translateService.instant('API Usage'), class: 'col-nowrap' },
  ];
  rangeOptions: SelectItem[] = [
    { label: '1', value: 1 },
    { label: '3', value: 3 },
    { label: '7', value: 7 },
    { label: '30', value: 30 },
    { label: '60', value: 60 },
    { label: '90', value: 90 },
    { label: '180', value: 180 },
    { label: '240', value: 240 },
    { label: '365', value: 365 },
  ];
  rangeOptionsUnit = TRANSLATE('Days');
  selectedRange: any = { label: '3 Days', value: 3 };
  dateBegin: Date;
  dateEnd: Date;
  defaultMaxTime: Date;
  apiNameEdit = true;
  apiSettingsDialog = false;
  apiKeyId: number;
  apiName: string;
  datePickStart: Date;
  datePickEnd: Date;
  minEndDate: Date;
  maxEndDate: Date;
  minInputYear: {};
  maxInputYear: {};
  start_ts: number;
  end_ts: number;
  isSuperAdmin= false;
  timezone = 0;
  @ViewChild(DialogComponent, { static: false }) childDialog: DialogComponent;
  constructor(
    private translateService: TranslateService, 
    private _location: Location,
    private store: Store<fromStore.State>,
    private ngxService: NgxUiLoaderService,
    private apiKeyService: ApiKeyService,
    private cryptoService: CryptoService,
    private messageService: MessageService,
    private route: ActivatedRoute, 
    private router: Router,) {
    
    // Get User Info
    this.store.pipe(select(fromStore.getCurrentUser)).subscribe(res => {
      this.isSuperAdmin = res.authority && res.authority === 2 ? true : false;
      if (!this.isSuperAdmin) {
        this.router.navigate(['/index']);
      };
    });
    
    this.maxInputYear = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: 1 };
    this.minInputYear = { year: 2020, month: 1, day: 1 };
    this.apiKeyId = parseInt(this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('apikeyid')), 10);
    this.getDefaultDate();
    this.store.dispatch(new fromFeature.GetApiKeys());
    this.store.select(fromStore.getApiKey).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined) {
        this.ngxService.start();
        res.map((i) => {
          if (this.apiKeyId === i.apiKeyId) {
            const expiredDate = this.fomatDate(i.ExpiredTime)
            const createDate = this.fomatDate(i.CreateTime)
            this.apikeydetailInfo = {
              account: i.Account,
              apiName: i.name,
              apiKey: i.apiKey,
              apiKeyId: i.apiKeyId,
              expiredDate: expiredDate,
              createDate: createDate,
              status: i.expired == true ? statusType[2] : i.status == true ? statusType[1] : statusType[0],
              expired: i.expired
            }
            this.apiName = i.name;
          }
          this.ngxService.stop();
        })
      }
    });

    this.store
      .select(fromStore.getUpdateInfoState)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (
          res.type === updateInfoType.UpdateApiKey) {
          this.messageService.clear();
          if (!res.isLoading && res.isLoaded && res.isSaved) {
            this.messageService.add({
              severity: TRANSLATE("success"),
              summary: res.msg,
            });
          } else if (!res.isLoading && res.isLoaded && !res.isSaved) {
            this.messageService.add({
              severity: 'error',
              summary: TRANSLATE("Update Fail"),
            });
          }
          this.resetUpdateInfoState();
          this.ngxService.stop();
        }
      });

    this.store.select(fromStore.getApiKeyUsage).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      this.apiKeyUsage = [];
      if (res !== undefined && res !== null && res.length > 0) {
        res.map((i) => {
          this.apiKeyUsage.push(
            {
              type: i.Url,
              usage: i.Count,
            }
          );
        })
      }
      this.ngxService.stop();
    });
  }

  
  ngOnInit() {
    this.updateDefaultMaxTime();
  }

  backClicked() {
    // this._location.back();
    this.router.navigate(['/management/api']);
  }

  updateDefaultMaxTime() {
    this.defaultMaxTime = new Date();
    this.defaultMaxTime.setHours(23);
    this.defaultMaxTime.setMinutes(59, 59, 999);
  }

  rangeLimitForStartDay() {
    if (this.dateEnd == null) {
      this.dateEnd = new Date();
    }
  }

  rangeLimitForEndDay() {
    if (this.dateBegin == null) {
      this.dateBegin = new Date(this.dateEnd.valueOf());
    }
  }

  showAPIEditDialog() {
    this.apiSettingsDialog = true;
  }

  saveAPISetting() {
    const param = {
      otp : '',
      id : this.apikeydetailInfo.apiKeyId,
      enable : this.apikeydetailInfo.status,
      name: this.apiName
    }
    this.store.dispatch(new fromFeature.UpdateApiKey(param));
    this.apiSettingsDialog = false;
  }

  getDefaultDate() {
    const today = new Date();
    this.timezone = (new Date().getTimezoneOffset()/60);
    const preDate = new Date(today);
    if (preDate.getUTCMonth() === 0) {
      preDate.setUTCFullYear(today.getUTCFullYear() - 1);
      preDate.setUTCMonth(11); // 0 表示1月
      preDate.setUTCDate(1); // 設置為1號
    } else {
      preDate.setUTCMonth(today.getUTCMonth() -1); // 0 表示1月
      preDate.setUTCDate(1); // 設置為1號
    }

    preDate.setUTCHours(0, 0, 0, 0);
    this.datePickEnd = today;
    this.datePickStart = preDate;
    this.minEndDate = preDate;
    this.maxEndDate = new Date(preDate.getTime() + 24 * 60 * 60 * 1000 * 364);
    let start_ts = preDate.getTime();
    this.start_ts = Math.floor(start_ts / 1000);
    let end_ts = today.getTime();
    this.end_ts = Math.floor(end_ts / 1000);
    if (this.start_ts < this.end_ts) {
      this.filterUsage()
    }
  }

  changeStartDate(event) {
    let startdate = ((event.getTime()/1000) - (this.timezone*3600));
    startdate = Math.floor(startdate);
    this.minEndDate = event;
    this.maxEndDate = new Date(event.getTime() + 24 * 60 * 60 * 1000 * 364);
    this.start_ts = startdate;
    if (this.start_ts < this.end_ts && this.end_ts < Math.floor(this.maxEndDate.getTime() / 1000)) {
      this.filterUsage()
    } else {
      this.apiKeyUsage = [];
      this.datePickEnd = null;
    }
  }

  changeEndDate(event) {
    let enddate = ((event.getTime()/1000) - (this.timezone*3600));
    let maxEndDate = this.maxEndDate.getTime();
    event.setMonth(event.getMonth() + 1, 1);
    event.setDate(event.getDate() - 1);
    let lastDayOfMonth = ((event.getTime()/1000) - (this.timezone*3600));
    lastDayOfMonth = Math.floor(lastDayOfMonth);
    if (enddate >= maxEndDate) {
      this.childDialog.dialogType.filterMonthLimit = true;
    }
    this.end_ts = lastDayOfMonth;
    if (this.start_ts < this.end_ts) {
      this.filterUsage()
    }
  }

  filterUsage() {
    const now = Math.floor(new Date().getTime() / 1000);
    const param = {
      otp : '',
      start_ts : this.start_ts,
      end_ts : this.end_ts >= now ? now : this.end_ts,
      key_id : this.apiKeyId
    }
    this.store.dispatch(new fromFeature.GetApiKeyUsage(param));
  }

  fomatDate(value) {
    const dateObject = new Date(value);
    const year = dateObject.getFullYear();
    const month = ('0' + (dateObject.getMonth() + 1)).slice(-2); // 月份是從0開始的，所以要加1
    const day = ('0' + dateObject.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }
}
